import myService from './my-service';

export default {
	myService
};
